import { render, staticRenderFns } from "./UserSvg.vue?vue&type=template&id=08449eac&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08449eac",
  null
  
)

export default component.exports